// extracted by mini-css-extract-plugin
export default {"backButton":"outletErrorBoundary_backButton__IImTZ","wrapper":"outletErrorBoundary_wrapper__Qkx5X","content":"outletErrorBoundary_content__AZM7w"};